/* eslint-disable react/jsx-props-no-spreading */
import { StyledElementProps } from '@udecode/plate';
import React from 'react';
import { BufferValue } from '~/editor/BufferEditor/types.plate';
import { AutocompleteInputElement } from '../../nodes';
import { MentionText } from './styles';

export const AutocompleteInputElementUI = (
  props: StyledElementProps<BufferValue, AutocompleteInputElement>
) => {
  const { attributes, children, element } = props;
  const { valid } = element;

  return (
    <MentionText {...attributes} $valid={valid}>
      {children}
    </MentionText>
  );
};
